/**
 * Which refusals a manager standing at the till can do something about.
 *
 * Kept apart from the component only because a file that exports both a
 * component and a plain value loses hot reloading, which is a small tax paid
 * every time somebody edits the till.
 *
 * All five open the box rather than only the first. A wrong PIN, a person who
 * cannot approve, an account that has been locked, and the seller trying to
 * approve for themselves are all things a second attempt can fix — usually by
 * fetching a different manager. Closing the box on those would send the
 * cashier back to a blank screen mid-sale, and what they do then is ring the
 * order through without the discount.
 */
export const APPROVAL_CODES = [
  'APPROVAL_REQUIRED',
  'NOT_AUTHORISED',
  'NOT_ALLOWED',
  'NOT_YOUR_OWN',
  'ACCOUNT_LOCKED',
];

export const needsApproval = (error) => APPROVAL_CODES.includes(error?.code);
